import {
    useState, useCallback, forwardRef, useImperativeHandle
} from 'react'
import { useForm } from 'react-hook-form'
import { Form, InputGroup } from 'react-bootstrap'

const FieldSubmitForm = function ({
    width, height, onChange, onSubmit
}, ref) {
    const formInputs = {
        width,
        height
    }

    const {
        register, reset, getValues, handleSubmit, formState: { errors }
    } = useForm({ ...formInputs, mode: 'onBlur' })
    const [submitStatus] = useState(false)
    const [validated] = useState(false)

    useImperativeHandle(
        ref,
        () => ({
            onValuesUpdate({ width, height }) {
                reset({
                    width,
                    height
                })
            },
            submit() {
                handleSubmit(onSubmit)()
            }
        })
    )

    const onChangeCallback = useCallback(() => {
        const formValues = getValues()
        onChange(formValues)
    }, [getValues, onChange])

    return (
        <Form
            ref={ref}
            className="field-form w-100"
            validated={validated}
            onChange={onChangeCallback}
        >
            <InputGroup className="mb-1" hasValidation>
                <InputGroup.Text className="w-30">Width (cm.)</InputGroup.Text>
                <Form.Control
                    {...register('width', { pattern: { value: /^[0-9\b]+$/, message: 'Value must be a number!' } })}
                    isInvalid={!!errors.width}
                    disabled={submitStatus}
                />
                {errors.width?.message ? (
                    <Form.Control.Feedback type="invalid">
                        {errors.width.message}
                    </Form.Control.Feedback>
                ) : (
                    <div className="feedback-mock" />
                )}

            </InputGroup>
            <InputGroup className="mb-1" hasValidation>
                <InputGroup.Text className="w-30">Height (cm.)</InputGroup.Text>
                <Form.Control
                    {...register('height', { pattern: { value: /^[0-9\b]+$/, message: 'Value must be a number!' } })}
                    isInvalid={!!errors.height}
                    disabled={submitStatus}
                />
                {errors.height?.message ? (
                    <Form.Control.Feedback type="invalid">
                        {errors.height.message}
                    </Form.Control.Feedback>
                ) : (
                    <div className="feedback-mock" />
                )}
            </InputGroup>
        </Form>
    )
}

export default forwardRef(FieldSubmitForm)
